import React from 'react';
import { DollarSign, Clock, CheckCircle2, TrendingUp } from 'lucide-react';
import { Promotion } from './types';
interface StatsBarProps {
  promotions: Promotion[];
}
export function StatsBar({
  promotions
}: StatsBarProps) {
  const totalPotential = promotions.reduce((sum, p) => sum + p.bonusAmount, 0);
  const activeCount = promotions.filter(p => p.status === 'active' || p.status === 'applied' || p.status === 'pending').length;
  const today = new Date();
  const expiringSoonCount = promotions.filter(p => {
    if (p.status !== 'active') return false;
    const deadline = new Date(p.deadline);
    const diffTime = deadline.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 && diffDays <= 14;
  }).length;
  const completedTotal = promotions.filter(p => p.status === 'completed').reduce((sum, p) => sum + p.bonusAmount, 0);
  return <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-158">
      <StatCard label="Total Potential" value={`$${totalPotential.toLocaleString()}`} icon={TrendingUp} color="text-blue-600" bg="bg-blue-50" data-id="element-159" />
      <StatCard label="Active Promos" value={activeCount.toString()} icon={CheckCircle2} color="text-green-600" bg="bg-green-50" data-id="element-160" />
      <StatCard label="Expiring Soon" value={expiringSoonCount.toString()} icon={Clock} color="text-orange-600" bg="bg-orange-50" data-id="element-161" />
      <StatCard label="Earned So Far" value={`$${completedTotal.toLocaleString()}`} icon={DollarSign} color="text-emerald-600" bg="bg-emerald-50" data-id="element-162" />
    </div>;
}
function StatCard({
  label,
  value,
  icon: Icon,
  color,
  bg
}: {
  label: string;
  value: string;
  icon: any;
  color: string;
  bg: string;
}) {
  return <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm flex items-center justify-between" data-id="element-163">
      <div data-id="element-164">
        <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-165">
          {label}
        </p>
        <p className="text-2xl font-bold text-gray-900 mt-1 font-mono" data-id="element-166">
          {value}
        </p>
      </div>
      <div className={`p-2 rounded-lg ${bg}`} data-id="element-167">
        <Icon className={`w-5 h-5 ${color}`} data-id="element-168" />
      </div>
    </div>;
}